import { Text } from 'farmhub-ui-core';

import { theme } from 'styled';
import { genCensorshipStatus } from 'utils';

interface StatusCellTableMobileProps {
  status: number;
  name?: string;
}

const StatusCellTableMobile = ({
  status,
  name = 'hoạt động',
}: StatusCellTableMobileProps): JSX.Element => {
  const getStatusText = () => {
    switch (status) {
      case 0:
        return `Đang ${name}`;
      case 1:
        return `Dừng ${name}`;
      case 2:
        return `Tạm dừng ${name}`;
      case 3:
        return `Chưa hoàn thành`;
      case 4:
        return `Tạm ẩn`;
      default:
        return '';
    }
  };

  const generateColor = (textColor: string) => {
    if (textColor == 'default') {
      return '#59636E';
    }

    return theme.colors[textColor];
  };

  return (
    <Text
      color={theme.colors.success}
      size="xxs"
      styles={{
        color: generateColor(genCensorshipStatus(status).color),
        width: 'fit-content',
        alignItems: 'center',
        display: 'flex',
      }}
      weight="bold"
    >
      {getStatusText()}
    </Text>
  );
};

export default StatusCellTableMobile;
